let type_style = "font-size: 1em; ";
let log_style =
  "color: white; padding: 10px; border-radius: 5px; background-color: blue";
let debug_style =
  "color: white; padding: 10px; border-radius: 5px; background-color: orange";

const Logger = {
  log: (context: string = "Logger", ...messages) => {
    console.log(
      "%c%s %c%s ",
      type_style,
      "INFO",
      log_style,
      `[${context}]`,
      ...messages
    );
  },
  error: (message: string) => {
    console.error("[ERROR]", "[Logger]", message);
  },
  warn: (message: string) => {
    console.warn("[WARN]", "[Logger]", message);
  },
  debug: (context: string = "Logger", ...messages) => {
    console.debug(
      "%c%s %c%s ",
      type_style,
      "DEBUG",
      debug_style,
      `[${context}]`,
      messages
    );
  }
};

export default Logger;
